import React, { FC, useMemo } from 'react';
import { Link } from 'react-router-dom';
import { AppRoutes } from '@/routes';
import { StatusDetailsProps } from './types';
import { CustomColumns, CustomTable } from '@/ui/components';
import { StatusDetails } from '@/types';

export const PipelineDataGridInner: FC<StatusDetailsProps> = ({
  statusDetailData,
}) => {
  const columns: CustomColumns<StatusDetails> = useMemo(
    () => [
      {
        dataIndex: 'serialNumber',
        title: 'Passport History',
        align: 'center',
        render: (value) => (
          <Link
            to={{
              pathname: AppRoutes.passport,
              search: `search=${value}`,
            }}
          >
            View
          </Link>
        ),
      },
      { dataIndex: 'serialNumber', title: 'Serial Number' },
      { dataIndex: 'productDesc', title: 'Product Desc' },
      { dataIndex: 'colourDesc', title: 'Colour Desc' },
      { dataIndex: 'locationCity', title: 'Location City' },
    ],
    [],
  );
  return (
    <CustomTable
      dataSource={statusDetailData || []}
      columns={columns}
      rowKey="serialNumber"
    />
  );
};
